import * as materials from "materials/legacy/legacy-triPlanar";
export { materials };
export default materials;
